/* 
PUBLIC PAGE 
*/
import React from "react";
import About from "../Components/About/About";
import Layout from "../Components/Layout/Layout";

export default function AboutPage() {
  return (
    <Layout>
        <About />
    </Layout>
  );
}
